// =============================================================================
// MeuDriver — PremiumBadge
// Badge "Premium" exibido ao lado do nome do aluno.
// =============================================================================

import { Crown } from 'lucide-react'
import { cn } from '@/lib/utils'

interface PremiumBadgeProps {
  className?: string
}

export function PremiumBadge({ className }: PremiumBadgeProps) {
  return (
    <span
      data-testid="premium-badge"
      className={cn(
        'inline-flex items-center gap-1 rounded-full bg-amber-100 px-2 py-0.5 text-[11px] font-semibold text-amber-700 ring-1 ring-amber-200',
        className,
      )}
    >
      <Crown className="h-3 w-3 shrink-0" />
      Premium
    </span>
  )
}
